import * as ApiHelper from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";

export interface QuotePayload {
  quoteNumber: string;
  items: QuotePayloadItem[];
}

export interface QuotePayloadItem {
  productCode: string;
  packageSize?: number;
  packageCode: string;
  quantity: number;
  confirmedQuantity?: number;
  quoteLine?: string;
  selectedDeliveryDate?: Date;
  selectedDeliveryDateIsManual: boolean;
  priceReference?: string;
  isRestrictedPackage: boolean;
  originCountry?: string;
  currencyIso: string;
}

const apiUrl = resolveApiUrl("/quote/split/checkout");

export async function sendData(payload: QuotePayload[], override: boolean): Promise<Response> {
  const packageToCartForm = JSON.stringify(payload);

  const url = `${apiUrl}?override=${override}`;

  const params: RequestInit = {
    body: packageToCartForm,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  };

  const res = await fetch(url, params);
  window.SCHA.updateMinicart?.();
  return res;
}
